import { PHONE_NUMBER } from '@/constants/Common'
import { LocalePerformance } from '../en/performance'

const performance: LocalePerformance = {
  myPerformance: 'Mi Rendimiento',
  wins: 'Victorias',
  losses: 'Derrotas',
  avgPoints: 'Media de Puntos',
  avgPts: 'Media Pts',
  avgPartner: 'Media Compañero',
  avgPtr: 'Media Cmp',
  avgOpponent: 'Media Oponente',
  win: 'Ganar',
  loss: 'Perder',
  reject: 'Rechazar',
  validate: 'Validar',
  validateMatch: 'Validar Partida',
  confirmValidateMatch:
    '¿Estás seguro de que deseas validar estos resultados? Si es así, la partida se finalizará y las clasificaciones de los jugadores se actualizarán.',
  matchSourceLeague: `Si estos resultados no son correctos, por favor, contacta con el director del evento o envía un mensaje al ${PHONE_NUMBER} con los resultados correctos.`,
  deleteMatchConfirm:
    'Si eliminas esta partida, tendrás que empezar de nuevo para ingresar puntuaciones y que esto afecte tu calificación.',
  halfLife: 'Media vida',
  avgOpp: 'Promedio arriba',
  matchesEmpty: '¡Aún no has jugado ningún partido!',
  matchesEmptyDes: 'Encuentra algunos jugadores con los que jugar ¡empieza tu viaje!',
}

export default performance
